export default __webpack_public_path__ + "static/media/i-livestream-blue.c7bc4b4a.svg";